import React, { useEffect, useState } from "react";
import { Box, Button, IconButton} from "@mui/material";
import FieldBuilder from "../FieldBuilder/FieldBuilder";
import CloseIcon from "@mui/icons-material/Close";
import classes from "./TableFieldsPopup.module.css";
import { updateButtonStyle, removeButtonStyle} from '../../../common/CSS/css-configs';
import DeleteIcon from '@mui/icons-material/Delete';

const TableFieldsPopup = ({ open, onClose, onSubmit, tableFields = [] }) => {
  useEffect(()=>{
    setTableFieldsArray(tableFields)
  }, [tableFields]);
  
  const [tableFieldsArray, setTableFieldsArray] = useState(tableFields);

  if (!open) return null;

  const handleAddSubField = () => {
    const newField = {};
    setTableFieldsArray([...tableFieldsArray, newField]);
  };

  const updateTableField = (field, index) => {
    console.log("Index for table field=================: ", index);
    console.log("Value for table field=================: ", field);
    setTableFieldsArray((prevFields) => {
      const updated = [...prevFields];
      
      if (field === undefined || field === null) {
        // 🧹 remove the field at this index
        updated.splice(index, 1);
      } else {
        // ✏️ update normally
        updated[index] = field;
      }

      return updated;
    });
  };


  const handleRemoveSubField = (index) => {
    const updated = tableFieldsArray.filter((_, i) => i !== index);
    setTableFieldsArray(updated);
  };

  const handleSubmit = () => {
    onSubmit(tableFieldsArray);
    onClose();
  };

  const handleRemove = () => {
    onSubmit([]);
    onClose();
  };

  return (
    <div className={classes.overlay}>
      <Box className={classes.popup}>
        <IconButton
            sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            }}
            onClick={onClose}
        >
            <CloseIcon />
        </IconButton>
        <h3>Table Fields</h3>
        <hr></hr>

        <Box className={classes.content}>
          {tableFieldsArray.map((field, index) => (
            <Box key={index} sx={{ mb: 4 }}>
                {/* <IconButton onClick={() => handleRemoveSubField(index)}>
                  <DeleteIcon sx={{ color: 'red' }} />
                </IconButton> */}
              <FieldBuilder
                field={field}
                indexFieldArray={index}
                updateFieldsArray={updateTableField}
                isTableField={true}
                checkForErroInField={false}
              />
            </Box>
          ))}

          <Button
            variant="contained"
            sx={{...updateButtonStyle, width: '100%'}}
            onClick={handleAddSubField}
          >
            + Add
          </Button>
        </Box>

        <Box className={classes.footer}>
          <Button onClick={handleSubmit} variant="contained" sx = {updateButtonStyle}>
            Update
          </Button>
          <Button onClick={handleRemove} variant="contained" sx = {removeButtonStyle}>
            Remove
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default TableFieldsPopup;
